// TODO - Documentar
import React, { useEffect, useRef } from 'react'
import { TICKER_TAPE } from '../../GlobalConstants'

function CustomTickerTape() {
    const containerRef = useRef(null);
    
    useEffect(() => {
        const container = containerRef.current;
        let widgetContainer = null;
        
        if (container) {
            const timer = setTimeout(() => {
                try {
                    container.innerHTML = '';
                    
                    widgetContainer = document.createElement('div');
                    widgetContainer.className = 'tradingview-widget-container';
                    
                    const widget = document.createElement('div');
                    widget.className = 'tradingview-widget-container__widget';
                    widgetContainer.appendChild(widget);
                    
                    container.appendChild(widgetContainer);
                    
                    const script = document.createElement('script');
                    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
                    script.async = true;
                    script.type = 'text/javascript';
                    
                    script.innerHTML = JSON.stringify({
                        "symbols": [
                            {
                                "proName": "FOREXCOM:SPXUSD",
                                "title": "S&P 500"
                            },
                            {
                                "proName": "FOREXCOM:NSXUSD",
                                "title": "Nasdaq 100"
                            },
                            {
                                "proName": "FX_IDC:EURUSD",
                                "title": "EUR/USD"
                            },
                            {
                                "proName": "BITSTAMP:BTCUSD",
                                "title": "BTC/USD"
                            },
                            {
                                "proName": "BITSTAMP:ETHUSD",
                                "title": "ETH/USD"
                            }
                        ],
                        "showSymbolLogo": true,
                        "colorTheme": "dark",
                        "isTransparent": false,
                        "displayMode": "regular",
                        "locale": "es"
                    });
                    
                    widgetContainer.appendChild(script);
                } catch (error) {
                    console.error('Error al cargar el widget de TradingView:', error);
                }
            }, 1000);
            
            return () => {
                clearTimeout(timer);
                if (container) {
                    container.innerHTML = '';
                }
            };
        }
    }, []); 
    
    return (
        <div 
            ref={containerRef}
            style={{height: `${TICKER_TAPE}vh`}} 
            className="customTickerTape"
        ></div>
    );
}

export default CustomTickerTape;